export default __webpack_public_path__ + "static/media/item_8.c64da3f8.png";